import React from 'react'
import './index.less'
function Foot() {
    return (
        <div id="foot">
            <span>Copyright © 2017 帝业化学. All Rights Reserved.</span>
            <a href="http://www.beian.miit.gov.cn/">沪ICP备1501234</a>
        </div>
    )
}

export default Foot